import _classCallCheck from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArray } from 'vega-util';
import { isBinning } from '../bin';
import { COLUMN, FACET_CHANNELS, ROW } from '../channel';
import { normalize, vgField } from '../channeldef';
import { reduce } from '../encoding';
import * as log from '../log';
import { hasDiscreteDomain } from '../scale';
import { DEFAULT_SORT_OP, isSortField } from '../sort';
import { isFacetMapping } from '../spec/facet';
import { contains, flatten } from '../util';
import { isVgRangeStep } from '../vega.schema';
import { buildModel } from './buildmodel';
import { assembleFacetData } from './data/assemble';
import { sortArrayIndexField } from './data/calculate';
import { parseData as _parseData } from './data/parse';
import { assembleLabelTitle as _assembleLabelTitle } from './header/assemble';
import { getHeaderChannel, getHeaderProperty } from './header/common';
import { HEADER_CHANNELS, HEADER_TYPES } from './header/component';
import { parseFacetHeaders } from './header/parse';
import { parseChildrenLayoutSize } from './layoutsize/parse';
import { ModelWithField } from './model';
import { replaceRepeaterInFacet } from './repeater';
import { assembleDomain, getFieldFromDomain } from './scale/domain';
import { assembleFacetSignals } from './selection/assemble';
export function facetSortFieldName(fieldDef, sort, opt) {
  return vgField(sort, Object.assign({
    suffix: "by_".concat(vgField(fieldDef))
  }, opt || {}));
}
export var FacetModel = /*#__PURE__*/function (_ModelWithField) {
  _inherits(FacetModel, _ModelWithField);

  function FacetModel(spec, parent, parentGivenName, repeater, config) {
    var _this;

    _classCallCheck(this, FacetModel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FacetModel).call(this, spec, 'facet', parent, parentGivenName, config, repeater, spec.resolve));
    _this.child = buildModel(spec.spec, _assertThisInitialized(_assertThisInitialized(_this)), _this.getName('child'), undefined, repeater, config, false);
    _this.children = [_this.child];
    var facet = replaceRepeaterInFacet(spec.facet, repeater);
    _this.facet = _this.initFacet(facet);
    return _this;
  }

  _createClass(FacetModel, [{
    key: "initFacet",
    value: function initFacet(facet) {
      // clone to prevent side effect to the original spec
      if (!isFacetMapping(facet)) {
        return {
          facet: normalize(facet, 'facet')
        };
      }

      return reduce(facet, function (normalizedFacet, fieldDef, channel) {
        if (!contains([ROW, COLUMN], channel)) {
          // Drop unsupported channel
          log.warn(log.message.incompatibleChannel(channel, 'facet'));
          return normalizedFacet;
        }

        if (fieldDef.field === undefined) {
          log.warn(log.message.emptyFieldDef(fieldDef, channel));
          return normalizedFacet;
        } // Convert type to full, lowercase type, or augment the fieldDef with a default type if missing.


        normalizedFacet[channel] = normalize(fieldDef, channel);
        return normalizedFacet;
      }, {});
    }
  }, {
    key: "channelHasField",
    value: function channelHasField(channel) {
      return !!this.facet[channel];
    }
  }, {
    key: "fieldDef",
    value: function fieldDef(channel) {
      return this.facet[channel];
    }
  }, {
    key: "parseData",
    value: function parseData() {
      this.component.data = _parseData(this);
      this.child.parseData();
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseChildrenLayoutSize(this);
    }
  }, {
    key: "parseSelections",
    value: function parseSelections() {
      // As a facet has a single child, the selection components are the same.
      // The child maintains its selections to assemble signals, which remain
      // within its unit.
      this.child.parseSelections();
      this.component.selection = this.child.component.selection;
    }
  }, {
    key: "parseMarkGroup",
    value: function parseMarkGroup() {
      this.child.parseMarkGroup();
    }
  }, {
    key: "parseAxesAndHeaders",
    value: function parseAxesAndHeaders() {
      this.child.parseAxesAndHeaders();
      parseFacetHeaders(this);
    }
  }, {
    key: "assembleSelectionTopLevelSignals",
    value: function assembleSelectionTopLevelSignals(signals) {
      return this.child.assembleSelectionTopLevelSignals(signals);
    }
  }, {
    key: "assembleSignals",
    value: function assembleSignals() {
      this.child.assembleSignals();
      return [];
    }
  }, {
    key: "assembleSelectionData",
    value: function assembleSelectionData(data) {
      return this.child.assembleSelectionData(data);
    }
  }, {
    key: "getHeaderLayoutMixins",
    value: function getHeaderLayoutMixins() {
      var layoutMixins = {};

      var _iterator = _createForOfIteratorHelper(FACET_CHANNELS),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var channel = _step.value;

          var _iterator2 = _createForOfIteratorHelper(HEADER_TYPES),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var headerType = _step2.value;
              var layoutHeaderComponent = this.component.layoutHeaders[channel];
              var headerComponent = layoutHeaderComponent[headerType];
              var facetFieldDef = layoutHeaderComponent.facetFieldDef;

              if (facetFieldDef) {
                var titleOrient = getHeaderProperty('titleOrient', facetFieldDef, this.config, channel);

                if (contains(['right', 'bottom'], titleOrient)) {
                  var headerChannel = getHeaderChannel(channel, titleOrient);
                  layoutMixins.titleAnchor = layoutMixins.titleAnchor || {};
                  layoutMixins.titleAnchor[headerChannel] = 'end';
                }
              }

              if (headerComponent && headerComponent[0]) {
                // set header/footerBand
                var sizeType = channel === 'row' ? 'height' : 'width';
                var bandType = headerType === 'header' ? 'headerBand' : 'footerBand';

                if (channel !== 'facet' && !this.child.component.layoutSize.get(sizeType)) {
                  // If facet child does not have size signal, then apply headerBand
                  layoutMixins[bandType] = layoutMixins[bandType] || {};
                  layoutMixins[bandType][channel] = 0.5;
                }

                if (layoutHeaderComponent.title) {
                  layoutMixins.offset = layoutMixins.offset || {};
                  layoutMixins.offset[channel === 'row' ? 'rowTitle' : 'columnTitle'] = 10;
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return layoutMixins;
    }
  }, {
    key: "assembleDefaultLayout",
    value: function assembleDefaultLayout() {
      var _this$facet = this.facet,
          column = _this$facet.column,
          row = _this$facet.row;
      var columns = column ? this.columnDistinctSignal() : row ? 1 : undefined;
      var align = 'all'; // Do not align the cells if the scale corresponding to the direction is indepent.
      // We always align when we facet into both row and column.

      if (!row && this.component.resolve.scale.x === 'independent') {
        align = 'none';
      } else if (!column && this.component.resolve.scale.y === 'independent') {
        align = 'none';
      }

      return Object.assign({}, this.getHeaderLayoutMixins(), columns ? {
        columns: columns
      } : {}, {
        bounds: 'full',
        align: align
      });
    }
  }, {
    key: "assembleLayoutSignals",
    value: function assembleLayoutSignals() {
      // FIXME(https://github.com/vega/vega-lite/issues/1193): this can be incorrect if we have independent scales.
      return this.child.assembleLayoutSignals();
    }
  }, {
    key: "columnDistinctSignal",
    value: function columnDistinctSignal() {
      if (this.parent && this.parent instanceof FacetModel) {
        // For nested facet, we will add columns to group mark instead
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return undefined;
      } else {
        // In facetNode.assemble(), the name is always this.getName('column') + '_layout'.
        var facetLayoutDataName = this.getName('column_domain');
        return {
          signal: "length(data('".concat(facetLayoutDataName, "'))")
        };
      }
    }
  }, {
    key: "assembleGroup",
    value: function assembleGroup(signals) {
      if (this.parent && this.parent instanceof FacetModel) {
        // Provide number of columns for layout.
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return Object.assign({}, this.channelHasField('column') ? {
          encode: {
            update: {
              // TODO(https://github.com/vega/vega-lite/issues/2759):
              // Correct the signal for facet of concat of facet_column
              columns: {
                field: vgField(this.facet.column, {
                  prefix: 'distinct'
                })
              }
            }
          }
        } : {}, _get(_getPrototypeOf(FacetModel.prototype), "assembleGroup", this).call(this, signals));
      }

      return _get(_getPrototypeOf(FacetModel.prototype), "assembleGroup", this).call(this, signals);
    }
    /**
     * Aggregate cardinality for calculating size
     */

  }, {
    key: "getCardinalityAggregateForChild",
    value: function getCardinalityAggregateForChild() {
      var fields = [];
      var ops = [];
      var as = [];

      if (this.child instanceof FacetModel) {
        if (this.child.channelHasField('column')) {
          var field = vgField(this.child.facet.column);
          fields.push(field);
          ops.push('distinct');
          as.push("distinct_".concat(field));
        }
      } else {
        for (var _i = 0, _arr = ['x', 'y']; _i < _arr.length; _i++) {
          var channel = _arr[_i];
          var childScaleComponent = this.child.component.scales[channel];

          if (childScaleComponent && !childScaleComponent.merged) {
            var type = childScaleComponent.get('type');
            var range = childScaleComponent.get('range');

            if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
              var domain = assembleDomain(this.child, channel);

              var _field = getFieldFromDomain(domain);

              if (_field) {
                fields.push(_field);
                ops.push('distinct');
                as.push("distinct_".concat(_field));
              } else {
                log.warn('Unknown field for ${channel}.  Cannot calculate view size.');
              }
            }
          }
        }
      }

      return {
        fields: fields,
        ops: ops,
        as: as
      };
    }
  }, {
    key: "assembleFacet",
    value: function assembleFacet() {
      var _this$component$data$ = this.component.data.facetRoot,
          name = _this$component$data$.name,
          data = _this$component$data$.data;
      var _this$facet2 = this.facet,
          row = _this$facet2.row,
          column = _this$facet2.column;

      var _this$getCardinalityA = this.getCardinalityAggregateForChild(),
          fields = _this$getCardinalityA.fields,
          ops = _this$getCardinalityA.ops,
          as = _this$getCardinalityA.as;

      var groupby = [];

      var _iterator3 = _createForOfIteratorHelper(FACET_CHANNELS),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var channel = _step3.value;
          var fieldDef = this.facet[channel];

          if (fieldDef) {
            groupby.push(vgField(fieldDef));
            var bin = fieldDef.bin,
                sort = fieldDef.sort;

            if (isBinning(bin)) {
              groupby.push(vgField(fieldDef, {
                binSuffix: 'end'
              }));
            }

            if (isSortField(sort)) {
              var field = sort.field,
                  _sort$op = sort.op,
                  op = _sort$op === void 0 ? DEFAULT_SORT_OP : _sort$op;
              var outputName = facetSortFieldName(fieldDef, sort);

              if (row && column) {
                // For crossed facet, use pre-calculate field as it requires a different groupby
                // For each calculated field, apply max and assign them to the same name as
                // all values of the same group should be the same anyway.
                fields.push(outputName);
                ops.push('max');
                as.push(outputName);
              } else {
                fields.push(field);
                ops.push(op);
                as.push(outputName);
              }
            } else if (isArray(sort)) {
              var _outputName = sortArrayIndexField(fieldDef, channel);

              fields.push(_outputName);
              ops.push('max');
              as.push(_outputName);
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var cross = !!row && !!column;
      return Object.assign({
        name: name,
        data: data,
        groupby: groupby
      }, cross || fields.length ? {
        aggregate: Object.assign({}, cross ? {
          cross: cross
        } : {}, fields.length ? {
          fields: fields,
          ops: ops,
          as: as
        } : {})
      } : {});
    }
  }, {
    key: "facetSortFields",
    value: function facetSortFields(channel) {
      var facet = this.facet;
      var fieldDef = facet[channel];

      if (fieldDef) {
        if (isSortField(fieldDef.sort)) {
          return [facetSortFieldName(fieldDef, fieldDef.sort, {
            expr: 'datum'
          })];
        } else if (isArray(fieldDef.sort)) {
          return [sortArrayIndexField(fieldDef, channel, {
            expr: 'datum'
          })];
        }

        return [vgField(fieldDef, {
          expr: 'datum'
        })];
      }

      return [];
    }
  }, {
    key: "facetSortOrder",
    value: function facetSortOrder(channel) {
      var facet = this.facet;
      var fieldDef = facet[channel];

      if (fieldDef) {
        var sort = fieldDef.sort;
        var order = (isSortField(sort) ? sort.order : !isArray(sort) && sort) || 'ascending';
        return [order];
      }

      return [];
    }
  }, {
    key: "assembleLabelTitle",
    value: function assembleLabelTitle() {
      var facet = this.facet,
          config = this.config;

      if (facet.facet) {
        // Facet always uses title to display labels
        return _assembleLabelTitle(facet.facet, 'facet', config);
      }

      var ORTHOGONAL_ORIENT = {
        row: ['top', 'bottom'],
        column: ['left', 'right']
      };

      var _iterator4 = _createForOfIteratorHelper(HEADER_CHANNELS),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var channel = _step4.value;

          if (facet[channel]) {
            var labelOrient = getHeaderProperty('labelOrient', facet[channel], config, channel);

            if (contains(ORTHOGONAL_ORIENT[channel], labelOrient)) {
              // Row/Column with orthogonal labelOrient must use title to display labels
              return _assembleLabelTitle(facet[channel], channel, config);
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return undefined;
    }
  }, {
    key: "assembleMarks",
    value: function assembleMarks() {
      var _this2 = this;

      var child = this.child; // If we facet by two dimensions, we need to add a cross operator to the aggregation
      // so that we create all groups

      var facetRoot = this.component.data.facetRoot;
      var data = assembleFacetData(facetRoot);
      var encodeEntry = child.assembleGroupEncodeEntry(false);
      var title = this.assembleLabelTitle() || child.assembleTitle();
      var style = child.assembleGroupStyle();
      var markGroup = Object.assign({
        name: this.getName('cell'),
        type: 'group'
      }, title ? {
        title: title
      } : {}, style ? {
        style: style
      } : {}, {
        from: {
          facet: this.assembleFacet()
        },
        // TODO: move this to after data
        sort: {
          field: flatten(FACET_CHANNELS.map(function (c) {
            return _this2.facetSortFields(c);
          })),
          order: flatten(FACET_CHANNELS.map(function (c) {
            return _this2.facetSortOrder(c);
          }))
        }
      }, data.length > 0 ? {
        data: data
      } : {}, encodeEntry ? {
        encode: {
          update: encodeEntry
        }
      } : {}, child.assembleGroup(assembleFacetSignals(this, [])));
      return [markGroup];
    }
  }, {
    key: "getMapping",
    value: function getMapping() {
      return this.facet;
    }
  }]);

  return FacetModel;
}(ModelWithField);